import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import { DataSourceSlugs } from 'Shared/constants/types';
import { trackClickedConnectApp } from 'Shared/tracking/tracking';

type Params = {
  redirectUrl?: string;
};

export function useConnectCalendar({ redirectUrl }: Params = {}) {
  const isCalendarConnected = useSelector(state => state.data_sources.find(ds => ds.isCalendar && ds.connected));
  const dataSources = useSelector(state => state.data_sources);

  const connectCalendar = useCallback(
    data_source_slug => {
      const dataSourcepath = dataSources.find(({ slug }) => slug === data_source_slug)?.path;
      if (dataSourcepath)
        window.location.href = `${dataSourcepath}${
          redirectUrl ? `&redirect_url=${redirectUrl}?set_recurring_meetings=true` : ''
        }`;
    },
    [dataSources, redirectUrl]
  );

  const handleConnectGoogleCalendar = useCallback(() => {
    trackClickedConnectApp(DataSourceSlugs.googleCalendarWorkspaceSync);
    connectCalendar(DataSourceSlugs.googleCalendarWorkspaceSync);
  }, [connectCalendar]);

  const handleConnectMicrosoftCalendar = useCallback(() => {
    trackClickedConnectApp(DataSourceSlugs.office365Calendar);
    connectCalendar(DataSourceSlugs.office365Calendar);
  }, [connectCalendar]);

  return {
    isCalendarConnected,
    handleConnectGoogleCalendar,
    handleConnectMicrosoftCalendar,
  };
}
